// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7zsIO","type":"styles_type__1qjSp","choices":"styles_choices__1wmlu"};